"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arc = exports.circleArc = exports.lineTo = exports.moveTo = void 0;
function moveTo(x, y) {
  return 'M' + x + ',' + y;
}
exports.moveTo = moveTo;
function lineTo(x, y) {
  return 'L' + x + ',' + y;
}
exports.lineTo = lineTo;
function circleArc(r, cx, cy, clockwise) {
  return this.arc(r, r, cx, cy + r, true, clockwise) + this.arc(r, r, cx, cy - r, true, clockwise);
}
exports.circleArc = circleArc;
function arc(rx, ry, endX, endY, largeArc, clockwise) {
  return 'A' + rx + ',' + ry + ' 0 ' + (largeArc ? 1 : 0) + ',' + (clockwise ? 1 : 0) + ' ' + endX + ',' + endY;
}
exports.arc = arc;
exports.default = {
  moveTo: moveTo,
  lineTo: lineTo,
  circleArc: circleArc,
  arc: arc
};